import axios from 'axios'

var qs = require('qs');
var root=process.env.API_ROOT


export const uploadUrl=root+"/api/avatar/upload"

export const commonUpload=(file,groupGuid,groupType,allowOpen,fixedFileName,isbatchsave)=> {
  var formdata1 = new FormData();// 创建form对象
  formdata1.append('groupGuid', groupGuid);
  formdata1.append('groupType', groupType);
  formdata1.append('allowOpen', allowOpen);
  formdata1.append('fixedFileName', fixedFileName);
  formdata1.append('isbatchsave', isbatchsave);
  formdata1.append('file', file, file.name);// 通过append向form对象添加数据,可以通过append继续添加数据
  let config = {
    headers: {'Content-Type': 'multipart/form-data'},
    timeout: 1000 * 60 * 5
  };   //添加请求头
  return axios.post(root + "/api/avatar/upload", formdata1,config)
}


export const editorUpload=(file)=> {
  var formdata1 = new FormData();// 创建form对象
  formdata1.append('file', file, file.name);// 通过append向form对象添加数据,可以通过append继续添加数据
  let config = {
    headers: {'Content-Type': 'multipart/form-data'},
    timeout: 1000 * 60 * 2
  };   //添加请求头
  return axios.post(root + "/api/avatar/editorupload", formdata1,config)
}

export const myphotoUpload=(file)=> {
  var formdata1 = new FormData();// 创建form对象
  formdata1.append('file', file, 'photo.png');// 通过append向form对象添加数据,可以通过append继续添加数据
  let config = {
    headers: {'Content-Type': 'multipart/form-data'},
    timeout: 1000 * 60 * 2
  };   //添加请求头
  return axios.post(root + "/api/avatar/myphotoupload", formdata1,config)
}

//获取列表数据
export const getListData = (params) => {
  return axios.get(root+'/api/avatar/list', {params:params})
}

//删除行
export const deleteData = (params) => {
  return axios.get(root+'/api/avatar/remove',  {params:params})
}

//获取具体文件路径
export const getURL = (params) => {
  return axios.get(root+'/api/avatar/geturl', {params:params})
}

export const getViewurl=() => {
  return axios.get(root + '/api/avatar/getViewurl')
}

//获取具体文件路径
export const attUUID = () => {
  function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }
  return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
}


//Excel文件导入本地
export const excelUpload=(file,yearflag)=> {
  var formdata1 = new FormData();// 创建form对象
  formdata1.append('file',file);
  formdata1.append("yearflag",yearflag)
  // 通过append向form对象添加数据,可以通过append继续添加数据
  let config = {
    headers: {'Content-Type': 'multipart/form-data'},
    // timeout: 1000 * 60 * 2
  };   //添加请求头
  return axios.post(root + "/warehouse/store/uploadExcel",formdata1,config)
}



// WEBPACK FOOTER //
// ./src/api/attachment.js